<template>
  <div>
    <v-row no-gutters align="center">
      <!-- Status app -->
      <strong>アプリ状況: </strong>
      <span>
        <v-chip
          small
          class="ml-2"
          color="green"
          text-color="white"
          v-if="!statusApp"
        >
          通常運用
        </v-chip>
        <v-chip
          small
          class="ml-2"
          color="orange"
          text-color="white"
          v-if="statusApp"
        >
          メンテ中
        </v-chip>
      </span>
      <v-spacer />
      <!-- Button show dialog create maintain -->
      <v-btn color="success" @click="dialogCreateMaintain = true"
        >新規作成</v-btn
      >
    </v-row>
    <!-- List maintain -->
    <v-layout class="row mx-1 mt-5" child-flex>
      <v-data-table
        :headers="headers"
        fixed-header
        :items="listMaintain"
        :loading="loadingGetListMaintain"
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        loading-text="読み込み中。。。待ってください。"
        hide-default-footer
        class="elevation-1"
      >
        <!-- Status -->
        <template v-slot:item.status="{ item: { status } }">
          <!-- If status maintain [実行中] -->
          <v-chip
            small
            color="green"
            class="status-maintain"
            text-color="white"
            v-if="status == 'MAINTAIN'"
          >
            {{ status | statusMaintain }}
          </v-chip>
          <!-- If status booking [予約] -->
          <v-chip
            small
            color="orange"
            class="status-maintain"
            text-color="white"
            v-if="status == 'BOOKING'"
          >
            {{ status | statusMaintain }}
          </v-chip>
          <!-- If status maintain end [終了] -->
          <v-chip small v-if="status == 'MAINTAIN_END'" class="status-maintain">
            {{ status | statusMaintain }}
          </v-chip>
        </template>
        <!-- CreatedAt -->
        <template v-slot:item.created_at="{ item: { created_at } }">
          {{ created_at | dateTime }}
        </template>
        <!-- Start time  maintain -->
        <template v-slot:item.start_time="{ item: { start_time } }">
          {{ (start_time * 1000) | dateTime }}
        </template>
        <!-- End time  maintain -->
        <template v-slot:item.end_time="{ item: { end_time } }">
          {{ (end_time * 1000) | dateTime }}
        </template>
        <template
          v-slot:item.actions="{ item, item: { end_time, Id, status } }"
        >
          <div class="d-flex justify-end">
            <!--  Edit -->
            <v-btn
              small
              color="primary"
              class="mr-3"
              v-if="
                (!end_time || end_time > new Date().getTime() / 1000) &&
                status != 'MAINTAIN_END'
              "
              @click="showDialogUpdate(item)"
              >編集</v-btn
            >
            <!-- Cancel -->
            <v-btn
              color="error"
              :class="{ 'mr-3': status != 'MAINTAIN' }"
              @click="showDialogComfirmCancel(Id)"
              small
              v-if="status == 'MAINTAIN'"
              >解除</v-btn
            >

            <!--  Detele -->
            <v-btn
              small
              color="error"
              v-if="status != 'MAINTAIN'"
              @click="showDialogComfirmDelete(Id)"
              >削除</v-btn
            >
          </div>
        </template>
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-layout>
    <v-row class="mx-1 mt-2">
      <strong class="mt-4 mr-2">表示件数</strong>
      <v-select
        class="max-width-1 mt-2"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <v-spacer />
      <BasePagination
        v-if="listMaintain.length > 0"
        class="mt-5"
        :pageCount="listMaintain.length"
        :pageSize="pagination.maxResultCount"
        @changePage="(value) => (pagination.page = value)"
      />
    </v-row>
    <!-- Dialog create maintain -->
    <DialogCreateMaintain
      v-model="dialogCreateMaintain"
      :data="listMaintain"
      :key="`DialogCreateMaintain-${keyDialogCreateMaintain}`"
      @resetList="fetchListMaintain"
    />
    <!-- Dialog update maintain -->
    <DialogUpdateMaintain
      v-model="dialogUpdateMaintain"
      :itemUpdate="itemUpdate"
      :data="listMaintain"
      @resetList="fetchListMaintain"
    />
    <!-- Dialog confirm delete -->
    <v-dialog v-model="dialogConfirmDelete" persistent max-width="350">
      <v-card>
        <v-card-title class="headline justify-center">
          <span>確認</span>
        </v-card-title>
        <v-card-text class="pb-0"> 削除します。よろしいですか </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="font-weight-bold"
            :loading="loadingDelete"
            @click="handleDeleteMaintain"
            small
            >OK</v-btn
          >
          <v-btn @click="dialogConfirmDelete = false" small>キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog confirm cancel -->
    <v-dialog v-model="dialogConfirmCancel" persistent max-width="350">
      <v-card>
        <v-card-title class="headline justify-center">
          <span>確認</span>
        </v-card-title>
        <v-card-text class="pb-0">
          メンテナンス即時解除します。よろしいですか
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="font-weight-bold"
            :loading="loadingCancel"
            @click="handleCancelMaintain"
            small
            >OK</v-btn
          >
          <v-btn @click="dialogConfirmCancel = false" small>キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import mixin from "@/mixin";
import DialogCreateMaintain from "./DialogCreateMaintain";
import DialogUpdateMaintain from "./DialogUpdateMaintain";
import {
  getRecoveMaintain,
  deleteRecoveMaintain,
  cancelRecoveMaintain,
} from "@/api/MasterData.api";
import BasePagination from "@/components/Pagination/BasePagination";
import vm from "@/main";
export default {
  mixins: [mixin.App],
  components: {
    DialogCreateMaintain,
    DialogUpdateMaintain,
    BasePagination,
  },
  data() {
    return {
      dialogCreateMaintain: false,
      dialogUpdateMaintain: false,
      dialogConfirmDelete: false,
      dialogConfirmCancel: false,
      actionId: "",
      //   Header list maintain
      headers: [
        // Status
        { text: "状態", value: "status" },
        // date
        { text: "日付", value: "created_at" },
        // Title
        { text: "タイトル", value: "title" },
        // Detail
        { text: "詳細", value: "content" },
        // Start time
        { text: "開始", value: "start_time" },
        // End time
        { text: "終了", value: "end_time" },
        // Action
        {
          text: this.$i18n.t("action-title"),
          value: "actions",
          width: "100px",
          align: "center",
        },
      ],
      //   List data
      listMaintain: [],
      //   Loading get list
      loadingGetListMaintain: false,
      //   Loading delete
      loadingDelete: false,
      //   Loading delete
      loadingCancel: false,
      //   key dialog create
      keyDialogCreateMaintain: 0,
      //   item Update
      itemUpdate: {},
    };
  },
  async mounted() {
    await this.fetchListMaintain();
  },
  filters: {
    statusMaintain: function (val) {
      let status =
        val == "MAINTAIN_END" ? "終了" : val == "BOOKING" ? "予約" : "実行中";
      return status;
    },
    dateTime: function (val) {
      const { $moment } = vm;
      if (!val) return "未定";
      return $moment(val).format("YYYY年MM月DD HH:mm");
    },
  },
  computed: {
    statusApp: function () {
      const { listMaintain, _ } = this;
      let check = _.find(listMaintain, function (o) {
        return o.status == "MAINTAIN";
      });
      console.log("check: ", check);
      if (!_.isEmpty(check)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    dialogCreateMaintain: function () {
      this.keyDialogCreateMaintain++;
    },
    "pagination.maxResultCount": function () {
      this.pagination.page = 1;
    },
  },
  methods: {
    fetchListMaintain: async function () {
      this.loadingGetListMaintain = true;
      const { result } = await getRecoveMaintain().catch(this.$toast.error);
      this.loadingGetListMaintain = false;
      if (!result) return;
      this.listMaintain = result;
    },
    showDialogComfirmDelete: function (id) {
      this.dialogConfirmDelete = true;
      this.actionId = id;
    },
    showDialogComfirmCancel: function (id) {
      this.dialogConfirmCancel = true;
      this.actionId = id;
    },
    showDialogUpdate: function (item) {
      console.log("item: ", item);
      this.itemUpdate = item;
      this.dialogUpdateMaintain = true;
    },
    handleDeleteMaintain: async function () {
      let params = {
        id: this.actionId,
      };
      this.loadingDelete = true;
      await deleteRecoveMaintain(params)
        .then(() => {
          this.dialogConfirmDelete = false;
          this.fetchListMaintain();
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data.result.error == "DELETE_MAINTAIN_FAIL"
          ) {
            this.$toast.error("メンテナンスしています。削除できません。");
            this.loadingDelete = false;
            this.dialogConfirmDelete = false;
            this.fetchListMaintain();
          }
        });
      this.loadingDelete = false;
    },
    handleCancelMaintain: async function () {
      let params = {
        id: this.actionId,
      };
      this.loadingCancel = true;
      await cancelRecoveMaintain(params)
        .then(() => {
          this.dialogConfirmCancel = false;
          this.fetchListMaintain();
        })
        .catch((error) => {
          console.log("error: ", error.response.data.result.error);
        });
      this.loadingCancel = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.status-maintain {
  min-width: 100px;
}
::v-deep .status-maintain span {
  margin: 0 auto;
}
</style>